import {
  GaugeIcon,
  LineChart,
  Settings2,
  BarChart3,
  Download,
  Zap,
} from "lucide-react";

const features = [
  {
    icon: GaugeIcon,
    title: "Real-time Analysis",
    description: "Instant processing of dyno data with live visualization"
  },
  {
    icon: LineChart,
    title: "Multi-format Support",
    description: "Compatible with MHD and BM3 data logs"
  },
  {
    icon: Settings2,
    title: "Precision Filtering",
    description: "Smart filtering for clean, accurate results"
  },
  {
    icon: BarChart3,
    title: "Unit Conversion",
    description: "Switch between metric and imperial units"
  },
  {
    icon: Download,
    title: "Export Options",
    description: "Save as PNG, PDF, or print your results"
  },
  {
    icon: Zap,
    title: "Peak Detection",
    description: "Automatic detection of peak performance"
  }
];

export const Features = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-8">
    {features.map((feature, index) => (
      <div
        key={index}
        className="p-4 rounded-lg bg-gradient-to-br hover:scale-105 transition-all"
        style={{
          background: [
            'from-blue-50 to-blue-100 dark:from-blue-950 dark:to-blue-900',
            'from-purple-50 to-purple-100 dark:from-purple-950 dark:to-purple-900',
            'from-green-50 to-green-100 dark:from-green-950 dark:to-green-900',
            'from-yellow-50 to-yellow-100 dark:from-yellow-950 dark:to-yellow-900',
            'from-pink-50 to-pink-100 dark:from-pink-950 dark:to-pink-900',
            'from-orange-50 to-orange-100 dark:from-orange-950 dark:to-orange-900',
          ][index]
        }}
      >
        <feature.icon className="w-8 h-8 text-primary mb-3" />
        <h3 className="text-sm font-semibold mb-1">{feature.title}</h3>
        <p className="text-xs text-muted-foreground">{feature.description}</p>
      </div>
    ))}
  </div>
);
